import React from "react";
import { Card, Row, Col, Result, Spin } from "antd";

import RateCardHeader from "./Header";
import OrganizationRateCardRouter from "routes/OrganizationRateCardRouter";
import {
  RateCardCitiesProvider,
  OrganizationRateCardProvider,
  useOrganizationRateCardContext,
  RateCardFacilitiesProvider,
} from "components/ratecard/contextProviders";
import { ReactQueryConfigProvider } from "react-query-legacy";
import FeatureFlagWrapper from "components/_common/FeatureFlagWrapper";

const OrganizationRateCardIndexPage: React.FC = () => {
  return (
    <ReactQueryConfigProvider config={{ retry: 0, refetchOnWindowFocus: false }}>
      <RateCardCitiesProvider>
        <RateCardFacilitiesProvider>
          <OrganizationRateCardProvider>
            <FeatureFlagWrapper feature="billingEngine">
              <RateCardLayout />
            </FeatureFlagWrapper>
          </OrganizationRateCardProvider>
        </RateCardFacilitiesProvider>
      </RateCardCitiesProvider>
    </ReactQueryConfigProvider>
  );
};

/**
 * Wrapper component just to make sure we have organization
 */
const RateCardLayout = () => {
  const { organizationRateCards, status } = useOrganizationRateCardContext();

  // Too many spinners
  if (status === "loading") {
    return (
      <Row id="loading-spinning">
        <Spin size="large" tip="Please wait..." />
      </Row>
    );
  }

  return organizationRateCards ? (
    <Row gutter={[0, 28]}>
      <Col span={24}>
        <RateCardHeader />
      </Col>
      <Col span={24}>
        <Card>
          <OrganizationRateCardRouter />
        </Card>
      </Col>
    </Row>
  ) : (
    <Result status="404" title="404" subTitle="Sorry, organization doesn't exists in the Billing Engine." />
  );
};

export default OrganizationRateCardIndexPage;
